import isUndefined from 'lodash/isUndefined';
import some from 'lodash/some';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import EnvironmentUtils from '@spothero/utils/environment';

export default class ProximityInformation extends Component {
    static propTypes = {
        amenities: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array
        ]).isRequired,
        distance: PropTypes.number,
        distanceInMiles: PropTypes.string,
        drivingDuration: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ]),
        walkingDuration: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ])
    };

    constructor(props) {
        super(props);

        this._isMobile = EnvironmentUtils.isMobileDevice();
    }

    _renderShuttle() {
        const {
            drivingDuration
        } = this.props;
        const dist = (!this._isMobile) ? ' distance' : '';

        if (!isUndefined(drivingDuration)) {
            const minutes = Math.floor(drivingDuration / 60);
            const seconds = drivingDuration - (minutes * 60);
            const display = (minutes) ? `${minutes} min` : `${seconds} sec`;

            return <span> (<span className="duration-value">{display}</span> shuttle ride)</span>;
        } else {
            return <span> walking{dist}</span>;
        }
    }

    _renderWalkingDuration() {
        const {
            walkingDuration
        } = this.props;

        if (!walkingDuration) { return ''; }

        const minutes = Math.floor(walkingDuration / 60);
        const seconds = walkingDuration - (minutes * 60);
        let display = (minutes) ? `${minutes} min` : `${seconds} sec`;

        if (minutes && seconds) {
            display = `${display}, ${seconds} sec`;
        }

        return ` (${display})`;
    }

    render() {
        const {
            distanceInMiles,
            distance,
            amenities
        } = this.props;

        return (
            <div className="ProximityInformation">
                <span className="distance">
                    {(!isUndefined(distanceInMiles))
                        ? distanceInMiles
                        : `${(distance / 1609).toFixed(2)} mi`
                    }
                </span>
                {(some(amenities, {slug: 'shuttle'}))
                    ? this._renderShuttle()
                    : ` walking${this._renderWalkingDuration()}`
                }
            </div>
        );
    }
}
